module.exports = __webpack_public_path__ + "static/img/list-bg-2.4008203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/list-bg-2.png
// module id = miWk
// module chunks = 1